import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user}
    : { status: { loggedIn: false }, user: null};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        changeCompanyAction({ commit }, companyID) {
            commit('changeCompany',companyID);
        },
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            commit('logout');
        },
        addTeam({ commit }, team) {
            commit('addTeam', team);
        },
        removeTeam({ commit }, team) {
            commit('removeTeam', team);
        },
        localStoreCleanup() {
            AuthService.logout();
        },
        changeProfil({commit}, user){
            commit('loginSuccess', user);
            return Promise.resolve(user);
        },
        updateToken({ commit }, token) {
            commit('updateToken', token);
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        registerLight({ commit }, user) {
            return AuthService.registerLight(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        changeCompany(state, companyID){
            state.user.companyID = companyID
        },
        addTeam(state, team) {
            state.user.teams.push({id : team.teamId, name : team.teamName});
            let item = JSON.parse(localStorage.getItem('user'));
            item.teams = state.user.teams
            localStorage.setItem('user',JSON.stringify(item))
        },
        removeTeam(state, teamId) {
            state.user.teams.splice(state.user.teams.findIndex(t => t.id === teamId),1);
            let item = JSON.parse(localStorage.getItem('user'));
            item.teams = state.user.teams
            localStorage.setItem('user',JSON.stringify(item))
        },
        updateToken(state, token) {
            state.user.accessToken = token;
            let item = JSON.parse(localStorage.getItem('user'));
            item.accessToken = state.user.accessToken
            localStorage.setItem('user',JSON.stringify(item))
        }
    },
    getters: {
        currComp(state){
            return state.user.companyID
        }
    }
};